/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Subscriptions_StatusInputs */

const en_admin_subscriptions_status = /** @type {(inputs: Admin_Subscriptions_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status`)
};

const zh_admin_subscriptions_status = /** @type {(inputs: Admin_Subscriptions_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`状态`)
};

/**
* | output |
* | --- |
* | "Status" |
*
* @param {Admin_Subscriptions_StatusInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_subscriptions_status = /** @type {((inputs?: Admin_Subscriptions_StatusInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Subscriptions_StatusInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_subscriptions_status(inputs)
	return zh_admin_subscriptions_status(inputs)
});
export { admin_subscriptions_status as "admin.subscriptions.status" }